import { modalActions } from "@context/modals";
import { toFarsiNumber } from "@utils/digits";
import { FC } from "react";
import { MODAL_TYPES } from "types/modals";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";

const InstructorMobile: FC = () => {
  const { activeFilters } = useExplorePreloadedData();
  if (!activeFilters) return <></>;

  const instructorLength = Object.entries(activeFilters)
    .filter(([filterName]) => filterName === "instructor_id")
    .reduce((curr, [, filterItem]) => curr + filterItem.filter_value.length, 0);

  const openCategoryFilter = () => {
    modalActions.addModal(MODAL_TYPES.EXPLORE_INSTRUCTOR, {
      config: {
        hideCloseIcon: true,
        useMobileClassName: true,
        modalClassName: " !h-[100vh] max-h-svh",
      },
    });
  };
  return (
    <div className="py-4     border-b border-fds-divider">
      <div className="flex py-2.5 justify-between items-center">
        <p className="title-md-medium " onClick={openCategoryFilter}>
          نام مدرس
        </p>
        <p className="text-fds-tertiary title-sm" onClick={openCategoryFilter}>
          {instructorLength
            ? `${toFarsiNumber(instructorLength)} مورد`
            : "انتخاب کنید"}
        </p>
      </div>
    </div>
  );
};

export default InstructorMobile;
